import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: a rating draws five stars; the paths and clip live in `IconSprite`. */
const HalfStar = ({ className }) => {
  return (
    <SpriteIcon
      symbol={SPRITE_SYMBOLS.halfStar}
      width="24"
      height="24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    />
  );
};

export default HalfStar;
